var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrsdLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 422.29,
    height: 129.56,
    viewBox: "0 0 422.29 129.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hrsd_logo",
    "data-name": "hrsd logo",
    transform: "translate(-0.03 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M95,164.92a1.81,1.81,0,0,0,2-1.82,2,2,0,1,0-4,0,1.82,1.82,0,0,0,2,1.82Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M100.3,164.92a1.81,1.81,0,0,0,2-1.82,2,2,0,1,0-4,0,1.82,1.82,0,0,0,2,1.82Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M105,184.59a1.85,1.85,0,0,0-2,1.81,2,2,0,0,0,4,0,1.85,1.85,0,0,0-2-1.81Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M110.24,184.59a1.85,1.85,0,0,0-2,1.81,2,2,0,0,0,4,0,1.84,1.84,0,0,0-2-1.81Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M122.64,174.74a3.72,3.72,0,0,1,3.88-4,9.32,9.32,0,0,1,3.88,1l1-2.94a13.48,13.48,0,0,0-5.15-1.26c-3.92,0-6.66,2.38-6.66,6.63a14.35,14.35,0,0,0,1,4.73h-6.78V167.74h-3.16v11.18h-8.54V167.74H97c-4.9,0-8.13,3-8.13,7.2h0c0,4.2,3.11,7.14,7.71,7.14h35.39V178.9h-7.86a7.74,7.74,0,0,1-1.47-4.16ZM99,178.92H96.3c-2.56,0-4.45-1.6-4.45-4h0c0-2.44,1.86-4,4.45-4H99Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M160.2,165.57a1.81,1.81,0,0,0,2-1.82,2,2,0,0,0-4,0,1.83,1.83,0,0,0,2,1.82Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M165.48,165.57a1.82,1.82,0,1,0,0-3.63,1.85,1.85,0,0,0-2,1.81,1.83,1.83,0,0,0,2,1.82Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M179.8,167.42a11.27,11.27,0,0,0-5.25,1.47l1.15,2.9a6.78,6.78,0,0,1,3.9-1.19c3.84,0,4.58,4.46,6.73,8.32h-16.1V167.74h-3.16v11.18h-8.55v-3.87c0-4.57-2.81-7.63-7-7.63h0c-4.22,0-7,3.05-7,7.61v-.06c0,2.73-1.32,3.95-3.83,3.95h-2.2v-17h-3.16V182.1h5.36c2.31,0,4.31-.57,5.21-2.32,1.22,1.71,3.21,2.32,5.67,2.32h39v-3.18C187.55,177.59,187.49,167.42,179.8,167.42Zm-24.44,11.5h-3.88A3.57,3.57,0,0,1,147.6,175h0c0-2.64,1.57-4.38,3.88-4.38h0c2.31,0,3.85,1.74,3.85,4.38Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M181.82,184.59a1.85,1.85,0,1,0,1.392.472A1.84,1.84,0,0,0,181.82,184.59Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M116.81,87.7H105.6v3.19h14.37V70.72h-3.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 3.18,
    height: 13.31,
    transform: "translate(108.95 72.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 3.16,
    height: 20.17,
    transform: "translate(124.09 70.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M227.32,163.1a2,2,0,1,0,2-2A2,2,0,0,0,227.32,163.1Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M232.6,163.1a2,2,0,1,0,2-2A2,2,0,0,0,232.6,163.1Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M239.24,184.59a1.85,1.85,0,0,0-2,1.81,2,2,0,1,0,4,0,1.85,1.85,0,0,0-2-1.81Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M244.53,184.59a1.85,1.85,0,0,0-2,1.81,2,2,0,0,0,4,0,1.84,1.84,0,0,0-2-1.81Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M272.82,165.59a1.82,1.82,0,0,0,2-1.84,2,2,0,1,0-2,1.84Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M283.44,161.94a1.85,1.85,0,0,0-2,1.81,2,2,0,0,0,4,0,1.85,1.85,0,0,0-2-1.81Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M287,163.75a2,2,0,1,0,2-1.81,1.85,1.85,0,0,0-2,1.81Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M300.84,178.92h-6.63V167.74h-3.16v11.18h-9.58V167.74h-3.16v11.18h-9v-3.87c0-4.57-2.81-7.63-7-7.63h0c-4.22,0-7,3.05-7,7.61v-.06c0,2.73-1.31,3.95-3.82,3.95h-3.22V167.74H245v11.18h-8.54V167.74h-5.17c-4.9,0-8.13,3-8.13,7.2h0c0,4.2,3.11,7.14,7.71,7.14h20.51c2.31,0,4.31-.57,5.21-2.32,1.22,1.71,3.21,2.32,5.67,2.32H304V161.94h-3.16Zm-67.57,0h-2.68c-2.56,0-4.45-1.6-4.45-4h0c0-2.44,1.87-4,4.45-4h2.68Zm32.84,0h-3.88a3.57,3.57,0,0,1-3.88-3.92h0c0-2.64,1.57-4.38,3.88-4.38h0c2.32,0,3.86,1.74,3.86,4.38Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 3.16,
    height: 20.17,
    transform: "translate(219.26 70.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M322.08,167.74c-4.9,0-8.14,3-8.14,7.2h0c0,4.2,3.11,7.14,7.71,7.14h2.41c-.08,1.74-1.3,2.29-3,2.29a13.85,13.85,0,0,1-4.17-.67l.64,3.36a13.45,13.45,0,0,0,3.66.49c4.05,0,6.09-1.49,6.09-6.29V167.74Zm2,7.11h0v4.07H321.4c-2.56,0-4.45-1.6-4.45-4h0c0-2.44,1.87-4,4.45-4h2.68Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M254.57,142.64c0-4.55-2.09-6.89-6.74-6.89h-2.21v3.16h2.66c2.19,0,3.31,1.12,3.31,3.43v4.59h-8.78v3.18h11.76Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M262.62,149.54V135.75h-3.19v14.31c0,2-.92,2.66-2.26,2.66-.65,0-1.19-.05-2-.12l-.3,2.76a8.751,8.751,0,0,0,2,.22C260.26,155.58,262.62,154.24,262.62,149.54Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 3.16,
    height: 20.17,
    transform: "translate(177.45 38.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M279.85,150.11h2.4c-.07,1.74-1.29,2.29-3,2.29a13.86,13.86,0,0,1-4.18-.67l.65,3.36a9.09,9.09,0,0,0,3,.49c3.8,0,6.46-1.31,6.68-5.47h6.77c2.18,0,4.05-.64,4.91-2.31,1.21,1.71,3.2,2.32,5.67,2.32h16.77V130h-3.16v17h-6.58v-3.87c0-4.57-2.81-7.63-7-7.63h0c-4.22,0-7,3-7,7.61v-.06c0,2.73-1.32,4-3.83,4h-6.43v-11.3h-5.17c-4.9,0-8.13,3-8.13,7.2h0C272.14,147.17,275.25,150.11,279.85,150.11Zm19-7.12c0-2.64,1.56-4.38,3.88-4.38h0c2.31,0,3.85,1.74,3.85,4.38v3.94h-3.87a3.56,3.56,0,0,1-3.88-3.92Zm-23.73,0c0-2.44,1.86-4,4.45-4h2.68v4h0v4.06H279.6c-2.56,0-4.45-1.6-4.45-4Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 3.16,
    height: 20.17,
    transform: "translate(234.79 38.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M153.81,132.93a1.81,1.81,0,0,0,2-1.81,2,2,0,1,0-4,0,1.82,1.82,0,0,0,2,1.81Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M148.53,132.93a1.81,1.81,0,0,0,2-1.81,2,2,0,1,0-4,0,1.82,1.82,0,0,0,2,1.81Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M150.06,150.11h17.29V135.75h-3.16v11.18h-8.54V135.75h-5.16c-4.9,0-8.14,3-8.14,7.2h0C142.35,147.17,145.46,150.11,150.06,150.11Zm-4.7-7.16c0-2.44,1.87-4,4.45-4h2.68v8h-2.68C147.25,146.95,145.36,145.35,145.36,142.95Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M195.55,131.28a1.68,1.68,0,0,0,1.85-1.68,1.86,1.86,0,1,0-1.85,1.68Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M193,135.27a1.77,1.77,0,1,0-1.343-.466A1.76,1.76,0,0,0,193,135.27Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M196.21,133.5a1.92,1.92,0,1,0,1.92-1.74,1.76,1.76,0,0,0-1.92,1.74Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M228.21,130h-3.16v17h-6.19V135.75H215.7v11.18h-8.54V135.75H204v11.18h-6.64v-9.18h-3.18v9.18h-5.77v-9.18h-3.16v9.18H177.1V135.45h-3.18v14.61c0,2-.92,2.66-2.26,2.66-.65,0-1.2-.05-2-.12l-.29,2.76a8.72,8.72,0,0,0,2,.22c3.23,0,5.59-1.24,5.74-5.47h51.14Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 3.16,
    height: 20.17,
    transform: "translate(143.47 38.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M160.24,154.42a2,2,0,1,0-2,2A2,2,0,0,0,160.24,154.42Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M165.52,154.42a2,2,0,1,0-2,2A2,2,0,0,0,165.52,154.42Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M211.38,152.63a1.86,1.86,0,0,0-2,1.81,2,2,0,1,0,2-1.81Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M411.23,124.7c.66.09,1.32.21,2,.32a104.333,104.333,0,0,1,10.55-15.81,113.61,113.61,0,0,0-33.45-18Zm54,42.47L430.78,156l40.47,64.77a112,112,0,0,0-6.03-53.6Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M408.75,142.22c14.92-23.88,34.37-41.31,62.5-51L430.78,156l-40.47,64.77C386.69,191.22,393.83,166.1,408.75,142.22Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M350.4,129.87l43.05,14A154.709,154.709,0,0,1,407.5,137q.93-2.28,2-4.56c1.17-2.55,2.43-5,3.74-7.42A130.41,130.41,0,0,0,350.4,129.87Zm117.71,14L430.78,156l80.38,26.12a129.929,129.929,0,0,0-43.05-38.27Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M350.4,182.1l45.94-14.93A124.724,124.724,0,0,1,402.1,154a109.858,109.858,0,0,1,5.4-17C384.73,146.75,365.66,161,350.4,182.1Zm99.93-57.4L430.78,156l80.38-26.11a130.19,130.19,0,0,0-60.83-5.19Z",
    transform: "translate(-88.84 -91.22)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrsdLogoWhite);
export default __webpack_public_path__ + "static/media/hrsd-logo-white.bf128c8b6c3b52069cde154f48b0cb07.svg";
export { ForwardRef as ReactComponent };